<script>

import ModuleWrapper from './ModuleWrapper.vue';
import AutoComplete from 'src/components/utils/sgs/AutoComplete.vue';
import moduleUtils from 'src/app/module/ModuleUtils';

import {mapActions} from 'vuex';

export default {
  name: 'Module',
  data: function() {
    return {
      autoComplete: null,
      exportPdfViewer: false,
      exportPdfViewerData: "",
      showDialogForm: {
        showDialogWithForm: false,
        formIdModal: '',
        parentIdModal: ''
      }
    }
  },
  components: {
    ModuleWrapper,
    AutoComplete
  },
  computed: {
    businessAreaId: function() {
      return this.$route.params.businessAreaId;
    },
    systemId: function() {
      return this.$route.params.systemId;
    },
    systemVersion: function() {
      return this.$route.params.systemVersion;
    },
    formId: function() {
      return this.$route.params.formId;
    },
    exportPdfViewerHeight: function() {
      return window.innerHeight - 100;
    }
  },
  methods: {
    ...mapActions([
      'showLoader',
      'hideLoader'
    ]),
    handleResize (event) {
      this.fullHeight = document.documentElement.clientHeight
    },
    eventAutoComplete: function (payload) {
      this.autoComplete = payload;
    },
    autoCompleteClose: function() {
      this.autoComplete = null;
    }
  },
  created: function () {

    this.$eventBus.$on('auto-complete', (payload) => {
      this.eventAutoComplete(payload);
    });

    this.$eventBus.$on('generate-report', (reportData) => {

      let formIdentifier = Object.assign({}, reportData.formIdentifier);
      formIdentifier.formId = reportData.formId;

      this.showLoader();

      moduleUtils.moduleFormGenerateReport(formIdentifier, reportData.instance, true)
        .then(response => {

          this.hideLoader();

          if (response.body) {
            this.notificationError = response.body.notificationError;
            this.notificationSuccess = response.body.notificationSuccess;
          }

          if (response.meta.code == 400) {

            _.forOwn(response.body.instance, (value, key) => {
              this.$set(this.instance, key, value);
            });

          } else if (response.meta.code == 500) {

            this.$notify({
              title: 'Error',
              message: this.$t('anUnexpectedErrorOccurred') + ' ' + response.error,
              type: 'error'
            });
          }
        });
    });

    this.$eventBus.$on('show-dialog-form', (formIdModal, parentIdModal) => {
      this.showDialogForm.formIdModal = formIdModal;
      this.showDialogForm.parentIdModal = parentIdModal;
      this.showDialogForm.showDialogWithForm = true;
    });

    this.$eventBus.$on('export-pdf', (businessRuleId, instance) => {

      this.showLoader();

      let formIdentifier = {
        businessAreaId: this.businessAreaId,
        systemId:  this.systemId,
        systemVersion: this.systemVersion,
        formId: this.formId
      }

      moduleUtils.generatePDF(formIdentifier,
        instance,
        businessRuleId
      ).then(response => {

        this.exportPdfViewerData = "";
        this.hideLoader();

        if (response.headers["content-type"] == "application/pdf") {

          let blob = new Blob([response.data], {
            type: 'application/pdf'
          });
          this.exportPdfViewerData = window.URL.createObjectURL(blob);
          this.exportPdfViewer = true;

        } else {

          let binaryString = String.fromCharCode.apply(null, new Uint8Array(response.data));

          response = JSON.parse(binaryString);

          if (response.body) {
            this.notificationError = response.body.notificationError;
            this.notificationSuccess = response.body.notificationSuccess;
          }

          if (response.meta.code == 400) {

            _.forOwn(response.body.instance, (value, key) => {
              this.$set(this.instance, key, value);
            });

          } else if (response.meta.code == 500) {

            this.$notify({
              title: 'Error',
              message: this.$t('anUnexpectedErrorOccurred') + ' ' + response.error,
              type: 'error'
            });
          }

        }
      })
    });

    this.$eventBus.$on('notification-error', (message) => {

      if (this.$i18n && message) {

        let label = message.pt;

        if (this.$i18n.locale == 'es' && message.es) {
          label = message.es;
        } else if (this.$i18n.locale == 'en' && message.en) {
          label = message.en;
        }

        if(label) {
          this.$alert(
            label,
            this.$t('error') + "!",
            {
              confirmButtonText: 'OK',
              type: 'error'
            }
          );
        }

      }

    });

    this.$eventBus.$on('notification-success', (message) => {

      if (this.$i18n && message) {

        let label = message.pt;

        if (this.$i18n.locale == 'es' && message.es) {
          label = message.es;
        } else if (this.$i18n.locale == 'en' && message.en) {
          label = message.en;
        }

        if(label) {
          this.$notify({
            title: this.$t('success'),
            message: label,
            type: 'success'
          });
        }

      }

    });
  }
}
</script>

<template>
  <module-template>
    <module-wrapper
      :businessAreaId="businessAreaId"
      :systemId="systemId"
      :systemVersion="systemVersion"
      :formId="formId"
    />

    <el-dialog
      title="SGSNow - Report Viewer"
      :visible.sync="exportPdfViewer"
      size="full">

      <object
        :data="exportPdfViewerData"
        type="application/pdf"
        width="100%"
        :height="exportPdfViewerHeight"
      />

    </el-dialog>

    <el-dialog :visible.sync="showDialogForm.showDialogWithForm" v-if="showDialogForm.showDialogWithForm" size="large" id="modal":modal="false">
      <module-template>

        <module-wrapper
          :businessAreaId="businessAreaId"
          :systemId="systemId"
          :systemVersion="systemVersion"

          :formId="showDialogForm.formIdModal"
          :parentId="showDialogForm.parentIdModal"
        />

      </module-template>
    </el-dialog>

    <auto-complete
      v-if="autoComplete"
      :payload="autoComplete.payload"
      :callback="autoComplete.callback"
      @autoCompleteClose="autoCompleteClose"
    />

  </module-template>
</template>



// WEBPACK FOOTER //
// Module.vue?c2313fbe